<template>
    <div class="col-lg-12">
        <card>
            <tabs type="info" :value="activeTab">
                <tab-pane
                    link="/settings/invoices"
                    label="Invoices"
                    class="py-4 px-2"
                >
                    <settings-invoices
                        :settings="settings"
                        @updateSettings="$emit('updateSettings', $event)"
                    />
                </tab-pane>
                <tab-pane link="/settings/emails" label="Emails">
                    <settings-emails
                        :settings="settings"
                        @updateSettings="$emit('updateSettings', $event)"
                    />
                </tab-pane>
            </tabs>
        </card>
    </div>
</template>
<script>
import { TabPane, Tabs } from "src/components/UI";
import SettingsInvoices from "./SettingsInvoices.vue";
import SettingsEmails from "./SettingsEmails.vue";

export default {
    name: "Settings",
    components: {
        TabPane,
        Tabs,
        SettingsInvoices,
        SettingsEmails,
    },
    props: {
        activeTab: {
            type: String,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
    },
};
</script>
